import { TourOfferDeparture, TourOfferSummary } from '~/types/tours/tourOffer';

import { request } from './common';
import { OkResponse, toursBasePath } from './toursApi';

export async function searchTourOffers(
  params: { search?: string; ltleOnly?: boolean },
  options?: { signal?: AbortSignal },
): Promise<Array<TourOfferSummary>> {
  const search = new URLSearchParams();
  if (params.search) {
    search.set('search', params.search);
  }
  if (params.ltleOnly) {
    search.set('ltleOnly', 'true');
  }
  const query = search.toString();

  const response: OkResponse<Array<TourOfferSummary>> = await request(
    `${toursBasePath()}/tour-offers${query ? `?${query}` : ''}`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}

export async function getTourOfferDepartures(
  tourOfferId: string,
  options?: { signal?: AbortSignal },
): Promise<Array<TourOfferDeparture>> {
  const response: OkResponse<Array<TourOfferDeparture>> = await request(
    `${toursBasePath()}/tour-offers/${tourOfferId}/departures`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}
